import { render, staticRenderFns } from "./Riego.vue?vue&type=template&id=f0b8b0b0&scoped=true&"
import script from "./Riego.vue?vue&type=script&lang=js&"
export * from "./Riego.vue?vue&type=script&lang=js&"
import style0 from "./Riego.vue?vue&type=style&index=0&id=f0b8b0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b8b0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/abimelec/repositories/nxtagro_op_front/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout})
